import React from 'react';
import { cssVar, Stack, Box, Text } from '@cad-arc';

export function LetterIcon(props: {
    type: 'dispatcher' | 'callTaker';
    label: string;
}): React.ReactElement {
    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Box
                borderRadius="sm"
                textAlign="center"
                display="inline"
                h="12px"
                w="12px"
                backgroundColor="text.primary"
            >
                <Text
                    fontWeight="bold"
                    lineHeight={1}
                    fontSize="xs"
                    style={{ color: cssVar('arc.colors.surface.canvas') }}
                >
                    {props.type === 'dispatcher' ? 'D' : 'C'}
                </Text>
            </Box>
            <Text lineHeight={1} fontSize="sm">
                {props.label}
            </Text>
        </Stack>
    );
}
